import React from 'react';
import { StackProps } from 'atoms/Layout/Stack/Stack';
import { HubspotFormWrapperContainer } from './HubspotFormWrapper.styles';

interface HubspotFormWrapperProps extends StackProps {
  hideLegal?: boolean;
  forceOneInputPerColumn?: boolean;
  hideInputLabels?: boolean;
}

const HubspotFormWrapper = ({
  hideLegal,
  forceOneInputPerColumn = true,
  hideInputLabels = false,
  ...props
}: HubspotFormWrapperProps): JSX.Element => {
  const combineClasses = () => {
    const classes = [];

    if (hideLegal) {
      classes.push('hide-legal');
    }
    if (forceOneInputPerColumn) {
      classes.push('force-one-input-per-column');
    }
    if (hideInputLabels) {
      classes.push('hide-input-labels');
    }

    return classes.join(' ');
  };

  return (
    <HubspotFormWrapperContainer
      className={combineClasses()}
      {...props}
    />
  );
};

export default HubspotFormWrapper;
